"use client";

import { useState } from "react";

// Digits are split into separate props so no full number ever appears as a
// single contiguous string in the served HTML/JS payload, defeating naive
// scraper regexes. The number also only renders after a user clicks.
type RevealPhoneProps = {
  area: string;
  prefix: string;
  line: string;
  label: string;
};

export function RevealPhone({ area, prefix, line, label }: RevealPhoneProps) {
  const [revealed, setRevealed] = useState(false);

  if (revealed) {
    const display = `${area}.${prefix}.${line}`;
    const tel = `+1${area}${prefix}${line}`;
    return (
      <a
        href={`tel:${tel}`}
        className="underline underline-offset-2 hover:text-slate-900 dark:hover:text-white"
      >
        {display} — {label}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setRevealed(true)}
      className="underline underline-offset-2 decoration-dotted hover:text-slate-900 dark:hover:text-white"
    >
      Show {label} phone number
    </button>
  );
}
